import { ReactNode } from 'react';
import { Div, Flex } from '@gaiads/telia-react-component-library';

import Header from '../Header';
import { PageHeader } from '../PageHeader';

import styles from './DetailsPageForOrganizationLayout.module.scss';
import OrganizationMenu from '../../OrganizationMenu/OrganizationMenu';

interface LayoutProps {
  children: ReactNode;
}

const DetailsPageForOrganizationLayout = ({ children }: LayoutProps) => {
  return (
    <>
      <Div className={styles['top-level-header-container']}>
        <Header />
      </Div>
      <Div className={styles['top-level-layout-container']}>
        <Flex>
          <PageHeader />
          <Div className={styles['organization-menu-container']}>
            <OrganizationMenu />
          </Div>
        </Flex>
        {children}
      </Div>
    </>
  );
};

export default DetailsPageForOrganizationLayout;
